import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_8yolqle2um: FaireBrandEntity = {
  token: "b_8yolqle2um",
  type: "brand",
  name: "munchrooms",
  avatarUrl:
    "https://cdn.faire.com/fastly/5ce29dfb48916c199ec992a20159391333d1edfb89cfae745bfa6f414a07cd74.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/44ac375ae2a7a70cc4be9d142c0843d1bb6f93cca06f8446f723a846c9db7c56.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/5ce29dfb48916c199ec992a20159391333d1edfb89cfae745bfa6f414a07cd74.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/44ac375ae2a7a70cc4be9d142c0843d1bb6f93cca06f8446f723a846c9db7c56.jpeg",
  location: "San Francisco, CA, USA",
  minimumOrderDollars: 60,
  rating: 5,
  reviewCount: 23,
  isInsider: true,
  description:
    "Established in 2020, munchrooms is an Asian-American, certified woman-owned, San Francisco-based company with a mission to make healthy snacking accessible and sustainable. Our handcrafted jerky, made from up-cycled shiitake mushroom stems, offers a meaty texture and bold, umami flavor. Infused with freshly ground spices, each pack delivers essential nutrients like selenium, potassium, vitamins B2 & B3, and vitamin D.\n\nIn addition to its health benefits, our jerky also provides a filling snack experience with a healthy serving of fiber in each pack. By offering Asian-inspired flavors, we aim to expand people's cultural palates and bring them together through a shared love of snacking. At munchrooms, we believe in providing plant-based alternatives that are good for both the body and the planet.",
  meta: {
    source: "api",
    importedAt: "2026-05-05T05:28:45.732Z",
    importedBy: "entity-db-cli",
  },
};
